import _request from '@/utils/request';
import { _getQuerystr } from '@/utils/commonUtils';

// POST
// /course/activityInstance/chat
// [员工]和小安聊天
export async function chatWithAIForCourseActivity(params) {
  const url = `/course/activityInstance/chat`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// POST
// /course/activityInstance/closeSession/{courseSessionId}
// [员工]课程聊天关闭会话
export async function closeCourseSessionForCourseActivity(courseSessionId) {
  const url = `/course/activityInstance/closeSession/${courseSessionId}`;
  return await _request({
    method: 'POST',
    url,
  })
}


// POST
// /course/activityInstance/complete
// [员工]完成了活动实例
export async function completeActivityInstanceForCourseActivity(courseActivityId) {
  return await _request({
    method: 'POST',
    url: `/course/activityInstance/complete?courseActivityInstanceId=${courseActivityId}`,
  })
}

// POST
// /course/activityInstance/dynamicResponse
// [员工]获取llm动态响应
export async function getDynamicResponseForCourseActivity(params) {
  const url = `/course/activityInstance/dynamicResponse`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// GET
// /course/activityInstance/messages
// [员工]根据courseSessionId查询消息列表
export async function getMessagesForCourseActivity(params) {
  // params: { courseSessionId, pageNo?, pageSize? }
  const url = `/course/activityInstance/messages${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// POST
// /course/activityInstance/next
// [员工]活动实例到下一个milestone
// data: { courseActivityInstanceId, mileStone: { content, index, milestoneId, milestoneName } }
export async function nextMilestoneForCourseActivity(data) {
  return await _request({
    method: 'POST',
    url: '/course/activityInstance/next',
    data,
  })
}

// POST
// /course/activityInstance/open
// [员工]创建或返回存在的活动实例
export async function openActivityInstanceForCourseActivity(courseActivityId, forceNew = false) {
  const url = `/course/activityInstance/open?courseActivityId=${courseActivityId}&forceNew=${forceNew}`;
  return await _request({
    method: 'POST',
    url,
  })
}

// POST
// /course/activityInstance/openSession
// [员工]实践课程聊天开启会话
export async function openCourseSessionForCourseActivity(data) {
  // data: { courseActivityInstanceId, forceNew, sessionType, skillId, theoryId, promptId?, sceneId? }
  return await _request({
    method: 'POST',
    url: '/course/activityInstance/openSession',
    data,
  })
}

// GET
// /course/activityInstance/scenes
// [员工]获取访谈场景
export async function getScenesForCourseActivity(params) {
  const url = `/course/activityInstance/scenes${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// GET
// /course/activityInstance/painPoints
// [员工]获取吐槽点
export async function getPainPointsForCourseActivity(courseActivityInstanceId) {
  const url = `/course/activityInstance/painPoints?courseActivityInstanceId=${courseActivityInstanceId}`;
  return await _request({
    method: 'GET',
    url,
  })
}
// POST
// /course/activityInstance/practice/sessions
// [员工]根据courseActivityInstanceId和skillId查询课程聊天会话列表
export async function getPracticeSessionsForCourseActivity(params) {
  const url = `/course/activityInstance/practice/sessions${_getQuerystr(params)}`;
  return await _request({
    method: 'POST',
    url,
  })
}

// GET
// /course/activityInstance/practice/sessions
// [员工]根据courseActivityInstanceId和skillId查询课程聊天会话列表
export async function getPracticeSessionsByCourseActivityInstanceIdAndSkillId(params) {
  const url = `/course/activityInstance/practice/sessions${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// POST
// /course/activityInstance/talks
// [员工]根据课程活动聊天会话列表
export async function getTalksByCourseActivityInstanceIdAndSkillId(params) {
  const url = `/course/activityInstance/talks${_getQuerystr(params)}`;
  return await _request({
    method: 'POST',
    url,
  })
}

// GET
// /course/activityInstance/theories
// [员工]获取理论实践列表
export async function getTheoriesForCourseActivity(courseActivityInstanceId) {
  const url = `/course/activityInstance/theories?courseActivityInstanceId=${courseActivityInstanceId}`;
  return await _request({
    method: 'GET',
    url,
  })
}
// GET : /course/activityInstance/summaryReport?courseSessionId=${courseSessionId} 查询访谈报告
export async function getSummaryReportForCourseActivity(courseSessionId) {
  const url = `/course/activityInstance/summaryReport?courseSessionId=${courseSessionId}`;
  return await _request({
    method: 'GET',
    url,
  })
}
// /course/activityInstance/summaryReportByActivityInstanceId
// [员工]根据courseActivityInstanceId查询最近的访谈报告
export async function getSummaryReportByActivityInstanceIdForCourseActivity(courseActivityInstanceId) {
  const url = `/course/activityInstance/summaryReportByActivityInstanceId?courseActivityInstanceId=${courseActivityInstanceId}`;
  return await _request({
    method: 'GET',
    url,
  })
}
